import { 
  Clipboard, 
  Monitor,
  BarChart3,
  Database,
  Settings
} from 'lucide-react'
import { BreadcrumbItem } from '@/components/ui/Header'

export interface BreadcrumbConfig {
  [path: string]: BreadcrumbItem[]
}

export const breadcrumbConfig: BreadcrumbConfig = {
  // Dashboard Routes
  '/dashboard/mytask': [
    { label: '현황', icon: <Monitor className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '내 현황' }
  ],
  '/dashboard/overall': [
    { label: '현황', icon: <Monitor className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '누적 현황' }
  ],
  '/dashboard/detail': [
    { label: '현황', icon: <Monitor className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '상세 현황' }
  ],
  '/dashboard/performance': [
    { label: '현황', icon: <Monitor className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '성과지표 현황' }
  ],
  '/dashboard/report/weekly': [
    { label: '현황', icon: <Monitor className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '주간 성과보고서' }
  ],
  '/dashboard/report/monthly': [
    { label: '현황', icon: <Monitor className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '월간 성과보고서' }
  ],
  '/dashboard/strategy': [
    { label: '현황', icon: <Monitor className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '누적 현황' }
  ],

  // Project Routes
  '/project/task': [
    { label: '프로젝트', icon: <Clipboard className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '과제/업무 관리' }
  ],
  '/project/performance': [
    { label: '프로젝트', icon: <Clipboard className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '성과지표 관리' }
  ],
  '/project/report': [
    { label: '프로젝트', icon: <Clipboard className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '보고서 관리' }
  ],
  '/project/meeting': [
    { label: '프로젝트', icon: <Clipboard className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '회의록 관리' }
  ],

  // Data Center Routes
  '/data/staff-workload': [
    { label: '데이터센터', icon: <Database className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '직원업무보유현황' }
  ],
  '/data/change-history': [
    { label: '데이터센터', icon: <Database className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '변경 이력' }
  ],
  '/data/university': [
    { label: '데이터센터', icon: <Database className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '대학알리미 공시' }
  ],
  '/data/export': [
    { label: '데이터센터', icon: <Database className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '데이터 일괄 다운로드' }
  ],

  // Setting Routes
  '/setting/member': [
    { label: '설정', icon: <Settings className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '멤버 관리' }
  ],
  '/setting/workspace': [
    { label: '설정', icon: <Settings className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '워크스페이스 관리' }
  ],

  // Default/Sample
  '/': [
    { label: '대시보드', icon: <BarChart3 className="w-3 h-[15px]" strokeWidth={2} /> },
    { label: '홈' }
  ]
}

export const getBreadcrumbs = (pathname: string): BreadcrumbItem[] => {
  // Exact match first
  if (breadcrumbConfig[pathname]) {
    return breadcrumbConfig[pathname]
  }

  // Try to find a partial match (for nested routes)
  const pathParts = pathname.split('/')
  while (pathParts.length > 0) {
    const testPath = pathParts.join('/')
    if (breadcrumbConfig[testPath]) {
      return breadcrumbConfig[testPath]
    }
    pathParts.pop()
  }

  // Return default breadcrumb if no match found
  return [
    { label: '페이지', icon: <Clipboard className="w-3 h-[15px]" strokeWidth={2} /> }
  ]
}